export default __webpack_public_path__ + "static/media/coins.2e00dece.wav";